import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateProperty'
})
export class TranslatePropertyPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(obj: any, propertyFr: string, propertyEn: string): any {
    if (!obj) return '';

    const lang = this.translate.currentLang; // 'fr' ou 'en'
    const prop = lang === 'fr' ? propertyFr : propertyEn;

    return obj[prop] || '';
  }
}
